import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import RGL, { WidthProvider } from "react-grid-layout";
import { useDispatch, useSelector } from "react-redux";
import Langs, { Localize } from "../../app/lang/langs";
import {
  checkPermission,
  isOwner,
  isAdmin
} from "../../app/utils/helpers";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import ImageButton from "../../components/buttons/ImageButton";
import { ShiftCell } from "../../components/scheduler/cells/shiftCell.js";
import { ShiftFormModal } from "../../components/scheduler/forms/ShiftFormModal.js";
import { generateSampleLeave } from "../../components/scheduler/leave/leaveSampleSlice";
import { hideFormPopup, setShowFormPopup } from "../planning/planningSlice";
import {
  getSettings,
} from "./settingsSlice";
import styles from "./Settings.module.css";
import {
  getHolidays,
} from "./settingsSlice";
import { config } from "../../app/utils/config.js";
import {
  addEvaluationField,
  deleteEvaluationField,
  setAddFieldResponse,
  setDeleteFieldResponse,
  reorderEvaluationsFields,
  reorderEvaluationTypes,
  setTypeModalVisibilty,
  setFieldModalVisibilty,
  setOnEditField,
  getEvaluationFields,
  getEvaluationsTypes,
  setOnEditType,
  setModifyTypeResponse,
  setSaveTypeConfigResponse
} from "../../components/evaluations/evaluationsSlice.js";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import EvaluationTypeModal from "./Modals/EvaluationTypeModal.js";
import EvaluationFieldModal from "./Modals/EvaluationFieldModal.js";
import PostesTab from "./PostesTab"
import SkillsTab from "./SkillsTab.js";
import GeneralSettingsTab from "./GeneralSettingsTab.js";
import ClientSettingsTab from "./ClientSettingsTab.js";
import ShiftTemplatesTab from "./ShiftTemplatesTab.js";
import HolidaysTab from "./HolidaysTab.js";
import MobileSettingsView from "./mobile/MobileSettingsView";
import MobileGeneralSettingsTab from "./mobile/MobileGeneralSettingsTab";
import MobileShiftTemplatesTab from "./mobile/MobileShiftTemplatesTab";
import MobilePostesTab from "./mobile/MobilePostesTab";
import MobileSkillsTab from "./mobile/MobileSkillsTab";
import SettingsPanelHeader from "../../components/settings/SettingsPanelHeader";
import SettingsEmptyState from "../../components/settings/SettingsEmptyState";
import MobileEvaluationsQuestionnaireTab from "./mobile/MobileEvaluationsQuestionnaireTab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
const ReactGridLayout = WidthProvider(RGL);
const pjson = require('../../../package.json');

// menuList holds raw French labels used both as i18n keys and as identity, so the
// icon and section for each entry are keyed off the same string.
const MENU_ICONS = {
  "Réglages généraux": "pi-sliders-h",
  "Réglages clients": "pi-building",
  "Modèles d'horaires": "pi-clock",
  "Jours fériés": "pi-calendar",
  "Postes": "pi-briefcase",
  "Questionnaire d'évaluations": "pi-check-square",
  "Compétence": "pi-star",
}

const MENU_GROUPS = {
  "Réglages généraux": "SETTINGS_GROUP_GENERAL",
  "Réglages clients": "SETTINGS_GROUP_GENERAL",
  "Modèles d'horaires": "SETTINGS_GROUP_PLANNING",
  "Jours fériés": "SETTINGS_GROUP_PLANNING",
  "Postes": "SETTINGS_GROUP_REFERENTIAL",
  "Compétence": "SETTINGS_GROUP_REFERENTIAL",
  "Questionnaire d'évaluations": "SETTINGS_GROUP_EVALUATIONS",
}

export function SettingsView() {

  const dispatch = useDispatch()

  const sampleLeavesRef = useRef()
  const mobileAddRef = useRef(null)

  const settings = useSelector((state) => state.settings)
  // const headerAction = useSelector((state) => state.common.headerAction)
  const sampleLeaves = useSelector((state) => state.sampleLeaves.list)
  const showFormPopup = useSelector((state) => state.planning.showFormPopup)
  const userRoleId = useSelector((state) => state.login.userRoleId)
  const permissions = useSelector((state) => state.login.permissions)
  const allEvaluationFields = useSelector((state) => state.evaluations.fieldsIgnoreActive)
  const deleteEvaluationFieldResponse = useSelector((state) => state.evaluations.deleteFieldResponse)
  const addEvaluationFieldResponse = useSelector((state) => state.evaluations.addFieldResponse)
  const evaluationsTypes = useSelector((state) => state.evaluations.typesIgnoreActive)
  const modifyTypeResponse = useSelector((state) => state.evaluations.modifyTypeResponse)
  const saveTypeConfigResponse = useSelector((state) => state.evaluations.saveTypeConfigResponse)
  const isMobile = useSelector((state) => state.settings.isMobile)

  const [menuList, setMenuList] = useState([])

  const [selectedMenu, setSelectedMenu] = useState(0)

  const [onAddEvaluationRowVisibility, setOnAddEvaluationRowVisibility] = useState(false)
  const [evaluationFieldTitle, setEvaluationFieldTitle] = useState("")
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [deleteFieldId, setDeleteFieldId] = useState(null)
  const [orderedFields, setOrderedFields] = useState()
  const [orederedTypes, setOrderedTypes] = useState(evaluationsTypes)
  const [selectedEvaluationTypeLocal, setSelectedEvaluationTypeLocal] = useState()

  const dtFields = useRef(null)
  const dtTypes = useRef(null)

  const mounted = useRef(null)

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      dispatch(getHolidays({ year: settings.selectedYear }))
    }
  })

  useEffect(() => {
    if (deleteEvaluationFieldResponse != null) {
      if (deleteEvaluationFieldResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(deleteEvaluationFieldResponse)
      }
      if (selectedEvaluationTypeLocal) {
        dispatch(getEvaluationFields({ idType: selectedEvaluationTypeLocal.id }))
      }
      dispatch(setDeleteFieldResponse(null))
    }
  }, [deleteEvaluationFieldResponse])

  useEffect(() => {
    if (addEvaluationFieldResponse != null) {
      if (addEvaluationFieldResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(addEvaluationFieldResponse)
      }
      if (selectedEvaluationTypeLocal) {
        dispatch(getEvaluationFields({ idType: selectedEvaluationTypeLocal.id }))
      }
      dispatch(setAddFieldResponse(null))
    }
  }, [addEvaluationFieldResponse])

  useEffect(() => {
    if (saveTypeConfigResponse != null) {
      if (saveTypeConfigResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(saveTypeConfigResponse)
      }
      dispatch(setSaveTypeConfigResponse(null))
    }
  }, [saveTypeConfigResponse])

  useEffect(() => {
    if (modifyTypeResponse != null) {
      if (modifyTypeResponse.trim().toLowerCase().includes("successfully")) {
        showSuccessToast("Success!")
      } else {
        showErrorToast(modifyTypeResponse)
      }
      dispatch(getEvaluationsTypes())
      dispatch(setModifyTypeResponse(null))
    }
  }, [modifyTypeResponse])

  useEffect(() => {
    let menuList = [];

    if (checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      menuList = [
        "Réglages généraux",
        //"Réglages clients",
        "Modèles d'horaires",
        "Jours fériés",
      ]
    } else if (checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      menuList = [
        "Réglages généraux",
        //"Réglages clients",
        "Jours fériés",
      ]
    } else {
      menuList = [
        "Réglages généraux",
        "Jours fériés",
      ]
    }

    if (isOwner(userRoleId) || checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      menuList.push("Postes")
    }
    if (isOwner(userRoleId) || checkPermission(config.scopes.settings, config.permissionTypes.edit)) {
      // Postes and Compétence are both referentials, so they sit together and the
      // evaluations questionnaire follows as its own section in the menu.
      menuList.push("Compétence")
      menuList.push("Questionnaire d'évaluations")
    }

    setMenuList(menuList)
    dispatch(getSettings())
  }, [dispatch, userRoleId, permissions])

  useEffect(() => {
    if (selectedMenu === menuList.indexOf("Questionnaire d'évaluations")) {
      dispatch(getEvaluationsTypes())
      if (selectedEvaluationTypeLocal) {
        dispatch(getEvaluationFields({ idType: selectedEvaluationTypeLocal.id }))
      }
    }
  }, [selectedMenu, selectedEvaluationTypeLocal, menuList])


  useEffect(() => {
    if (selectedEvaluationTypeLocal)
      setOrderedFields(allEvaluationFields)
  }, [allEvaluationFields])

  useEffect(() => {
    setOrderedTypes(evaluationsTypes)
  }, [evaluationsTypes])



  const handleAddSampleLeave = (event) => {
    let heureDebut = 9, heureFin = 17
    Object.values(settings.settingsList).map(item => {
      if (item.label === "Heure début de journée") heureDebut = item.settingValue
      if (item.label === "Heure fin de journée") heureFin = item.settingValue
    })
    dispatch(
      setShowFormPopup({
        type: "ADD_SAMPLE_LEAVE",
        data: generateSampleLeave(heureDebut, heureFin),
      })
    )
  }

  function constructLayoutForSampleLeaves() {
    let layout = []
    for (let i = 0; i < sampleLeaves.length; i++) {
      let leave = sampleLeaves[i];
      layout.push({
        i: leave["id"],
        x: i,
        y: 0,
        w: 1,
        h: 1,
        maxH: 1,
        minH: 1,
        data: leave,
      })
    }
    return layout
  }

  const handleAddEvaluationFieldVisibility = () => {
    setOnAddEvaluationRowVisibility(true);
  }

  const handleDeleteEvaluationField = (id) => {
    if (isAdmin(userRoleId) && deleteFieldId != null) {
      dispatch(deleteEvaluationField({ field_id: id }))
      setConfirmDeleteDialog(false);
      setDeleteFieldId(null)
    }
  }

  const handleAddEvaluationField = () => {
    if (isAdmin(userRoleId) && selectedEvaluationTypeLocal) {
      dispatch(addEvaluationField({ title: evaluationFieldTitle, idType: selectedEvaluationTypeLocal.id, rank: allEvaluationFields.length }));
      handleCancelAddField()
    }
  }

  const handleCancelAddField = () => {
    setEvaluationFieldTitle('')
    setOnAddEvaluationRowVisibility(false)
  }

  /**
   * Inline "new question" composer, shown under the questions list.
   *
   * Was a Bootstrap row with two ImageButtons (32px and 22px images, no gap between them,
   * hover-only tooltips). At thumb size those are neither hittable nor labelled, and the
   * confirm button only existed once the field was non-empty, so the row jumped as you
   * typed. Now: a 16px input (below 16px iOS Safari zooms the whole page on focus and the
   * user cannot get back), and two labelled buttons at least 44px tall, the primary one
   * disabled rather than absent.
   *
   * Same handlers, same dispatch: handleAddEvaluationField / handleCancelAddField.
   */
  function renderAddEvaluationRow() {
    if (!onAddEvaluationRowVisibility) return null
    const canSubmit = evaluationFieldTitle.trim() !== ''
    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1.25,
          px: 2,
          py: 1.75,
          backgroundColor: "#eefaf0",
          borderTop: "1px solid rgba(0,40,128,0.07)",
        }}
      >
        <TextField
          autoFocus
          value={evaluationFieldTitle}
          onChange={(e) => { setEvaluationFieldTitle(e.target.value) }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && canSubmit) handleAddEvaluationField()
            if (e.key === "Escape") handleCancelAddField()
          }}
          placeholder={Localize("SETTINGS_EVAL_QUESTION_PLACEHOLDER")}
          inputProps={{ "aria-label": Localize("SETTINGS_EVAL_QUESTION_PLACEHOLDER") }}
          sx={{
            flex: "1 1 240px",
            minWidth: 0,
            "& .MuiInputBase-input": { fontSize: "16px", py: "11px" },
            "& .MuiOutlinedInput-root": {
              backgroundColor: "#fff",
              borderRadius: "10px",
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "rgb(255,144,21)" },
            },
          }}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0, ml: "auto" }}>
          <Button
            onClick={() => { handleCancelAddField() }}
            startIcon={<CloseRoundedIcon />}
            sx={{
              minHeight: 44,
              px: 2,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              color: "rgba(45,42,38,0.7)",
            }}
          >
            <Langs str="CANCEL" />
          </Button>
          <Button
            onClick={() => { handleAddEvaluationField() }}
            disabled={!canSubmit}
            variant="contained"
            disableElevation
            startIcon={<CheckRoundedIcon />}
            sx={{
              minHeight: 44,
              px: 2.5,
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: "rgb(255,144,21)",
              "&:hover": { backgroundColor: "#e07600" },
            }}
          >
            <Langs str="ADD" />
          </Button>
        </Box>
      </Box>
    )
  }

  const handleReorderFields = (e) => {
    const { value } = e;
    let reorderedFields = [...value]
    reorderedFields = reorderedFields.map((field, index) => ({
      ...field,
      rank: index
    }));
    const requestArray = reorderedFields.map(field => ({
      id: field.id,
      rank: field.rank
    }));
    dispatch(reorderEvaluationsFields(requestArray))
    setOrderedFields(reorderedFields);
  }

  const handleReorderTypes = (e) => {
    const { value } = e;
    let reorderedTypes = [...value]
    reorderedTypes = reorderedTypes.map((type, index) => ({
      ...type,
      rank: index
    }));
    const requestArray = reorderedTypes.map(type => ({
      id: type.id,
      rank: type.rank
    }));
    dispatch(reorderEvaluationTypes(requestArray))
    setOrderedTypes(reorderedTypes);
  }

  /* Row actions. ImageButton renders a bare <img> inside a width:auto button, so the tap
     target was the image itself (22-32px) and its only label was a hover tooltip — i.e. no
     label at all on touch, and no accessible name anywhere. MUI IconButtons give a real
     40px target, a title and an aria-label. */
  const rowActionSx = (tint, tintSoft, tintBorder) => ({
    width: 40,
    height: 40,
    borderRadius: "10px",
    color: tint,
    backgroundColor: tintSoft,
    border: `1px solid ${tintBorder}`,
    "&:hover": { backgroundColor: tintBorder },
  })

  const handleEditField = (rowData) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1 }}>
        <IconButton
          aria-label={Localize("EDIT")}
          title={Localize("EDIT")}
          onClick={() => { dispatch(setFieldModalVisibilty(true)); dispatch(setOnEditField(rowData.id)) }}
          sx={rowActionSx("rgb(255,144,21)", "rgba(255,144,21,0.08)", "rgba(255,144,21,0.2)")}
        >
          <EditRoundedIcon sx={{ fontSize: 19 }} />
        </IconButton>
        {/* handleDeleteEvaluationField refuses non-admins, so for everyone else this
            button used to be a control that silently did nothing. Hidden instead.
            Extra left margin keeps the destructive action off the safe one. */}
        {isAdmin(userRoleId) && (
          <IconButton
            aria-label={Localize("DELETE")}
            title={Localize("DELETE")}
            onClick={() => { setConfirmDeleteDialog(true); setDeleteFieldId(rowData.id) }}
            sx={{ ...rowActionSx("#c62828", "rgba(198,40,40,0.06)", "rgba(198,40,40,0.18)"), ml: 0.5 }}
          >
            <DeleteOutlineRoundedIcon sx={{ fontSize: 19 }} />
          </IconButton>
        )}
      </Box>
    )
  }

  const handleEditType = (rowData) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <IconButton
          aria-label={Localize("EDIT")}
          title={Localize("EDIT")}
          onClick={() => { dispatch(setTypeModalVisibilty(true)); dispatch(setOnEditType(rowData.id)) }}
          sx={rowActionSx("rgb(255,144,21)", "rgba(255,144,21,0.08)", "rgba(255,144,21,0.2)")}
        >
          <EditRoundedIcon sx={{ fontSize: 19 }} />
        </IconButton>
      </Box>
    )
  }

  // Inactive rows used to be flagged by a pink row background alone — colour as the only
  // signal, and it fought the selected-row highlight. The class now only mutes the row;
  // the word "Inactive" is rendered as a chip in the row body.
  const rowClass = (rowData) => {
    if (rowData && !rowData.active) return "evalRowInactive"
    return ""
  }

  const typeScopeLabel = (row) => {
    const teams = row && Array.isArray(row.associated_teams) ? row.associated_teams : []
    if (teams.length === 0) return <Langs str="SETTINGS_EVAL_TYPE_ALL_TEAMS" />
    if (teams.length === 1) return <Langs str="SETTINGS_EVAL_TYPE_TEAMS_ONE" params={{ count: teams.length }} />
    return <Langs str="SETTINGS_EVAL_TYPE_TEAMS_MANY" params={{ count: teams.length }} />
  }

  const inactiveChipSx = {
    height: 22,
    fontSize: "11.5px",
    fontWeight: 600,
    color: "#8a2c1c",
    backgroundColor: "rgba(138,44,28,0.10)",
  }

  // The type row carries the two properties that decide whether a type is actually in play:
  // whether it is active at all, and which teams it is scoped to. Neither was visible, so
  // the list read as a set of interchangeable titles.
  const typeBody = (rowData) => {
    if (!rowData) return null
    return (
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, minWidth: 0 }}>
        <Typography
          component="span"
          sx={{ fontSize: "14px", fontWeight: 600, color: "rgb(0,40,128)", minWidth: 0, wordBreak: "break-word" }}
        >
          {rowData.title}
        </Typography>
        {!rowData.active && (
          <Chip size="small" label={<Langs str="INACTIVE" />} sx={inactiveChipSx} />
        )}
        <Typography component="span" sx={{ fontSize: "12px", color: "rgba(45,42,38,0.55)", whiteSpace: "nowrap" }}>
          {typeScopeLabel(rowData)}
        </Typography>
      </Box>
    )
  }

  const handleTypeRowClick = (event) => {
    if (Array.isArray(event.value)) {
      setSelectedEvaluationTypeLocal(event.value[0])
    } else {
      setSelectedEvaluationTypeLocal(event.value)
    }
  }

  /* PrimeReact table chrome, restyled from the wrapper's sx so the two tables read as part
     of their card instead of as a default DataTable dropped into one. Selection gets an
     accent bar as well as a tint, so it survives the muted-row styling. */
  const evalTableSx = {
    "& .p-datatable .p-datatable-thead > tr > th": {
      backgroundColor: "#f6f7fb",
      borderWidth: "0 0 1px 0",
      borderColor: "rgba(0,40,128,0.07)",
      padding: "10px 14px",
      fontFamily: "roboto-medium, roboto",
      fontSize: "11.5px",
      fontWeight: 700,
      letterSpacing: "0.07em",
      textTransform: "uppercase",
      color: "rgba(45,42,38,0.5)",
    },
    "& .p-datatable .p-datatable-tbody > tr > td": {
      padding: "8px 14px",
      borderWidth: "0 0 1px 0",
      borderColor: "rgba(0,40,128,0.06)",
      fontSize: "14px",
    },
    "& .p-datatable .p-datatable-tbody > tr.evalRowInactive > td": {
      backgroundColor: "transparent",
      opacity: 0.6,
    },
    "& .p-datatable .p-datatable-tbody > tr.p-highlight": {
      backgroundColor: "rgba(255,144,21,0.10)",
      color: "inherit",
      boxShadow: "inset 3px 0 0 rgb(255,144,21)",
    },
    "& .p-datatable .p-datatable-tbody > tr:focus-visible": {
      outline: "2px solid rgba(255,144,21,0.6)",
      outlineOffset: "-2px",
    },
    "& .p-datatable .p-row-toggler, & .p-datatable .p-datatable-reorderablerow-handle": {
      cursor: "grab",
      color: "rgba(0,40,128,0.35)",
    },
  }

  function renderEvaluationTypes() {
    return (
      <Box className={styles.panelTable} sx={evalTableSx}>
        <DataTable ref={dtTypes}
          value={orederedTypes}
          reorderableRows
          onRowReorder={(e) => handleReorderTypes(e)}
          dataKey="id"
          scrollable
          scrollHeight="calc(100vh - 260px)"
          sortMode="single"
          sortField="rank"
          selectionMode="single"
          rowClassName={rowClass}
          selection={selectedEvaluationTypeLocal}
          onSelectionChange={handleTypeRowClick}
          emptyMessage={
            <SettingsEmptyState
              icon="pi-check-square"
              title={<Langs str="SETTINGS_EVAL_TYPES_EMPTY_TITLE" />}
              description={<Langs str="SETTINGS_EVAL_TYPES_EMPTY_DESC" />}
            />
          }
        >
          <Column rowReorder style={{ width: '3rem', maxWidth: '3rem' }} />
          <Column field="title" body={typeBody} header={<Langs str="TYPE" />}></Column>
          <Column field="id" body={handleEditType} style={{ width: '4.5rem', maxWidth: '4.5rem' }} alignFrozen="right" frozen={true}></Column>
        </DataTable>
      </Box>
    )
  }

  // Read-only marker; the flag is edited in EvaluationFieldModal alongside the title.
  // Worth surfacing in the list because it is the one field property that changes other
  // people's primes — hence the hint on the chip rather than a bare badge.
  const teamImpactBody = (row) => {
    if (Number(row.team_impact) !== 1) return null
    return (
      <Chip
        size="small"
        label={<Langs str="EVAL_FIELD_TEAM_IMPACT" />}
        title={Localize("EVAL_FIELD_TEAM_IMPACT_HINT")}
        sx={{
          height: 22,
          fontSize: "11.5px",
          fontWeight: 600,
          color: "#8a5200",
          backgroundColor: "rgba(255,144,21,0.16)",
          border: "1px solid rgba(255,144,21,0.35)",
        }}
      />
    )
  }

  const questionBody = (row) => {
    if (!row) return null
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        <Typography component="span" sx={{ fontSize: "14px", color: "rgba(0,0,0,0.82)", minWidth: 0, wordBreak: "break-word" }}>
          {row.title}
        </Typography>
        {!row.active && (
          <Chip size="small" label={<Langs str="INACTIVE" />} sx={inactiveChipSx} />
        )}
      </Box>
    )
  }

  function renderEvaluationFields() {
    return (
      <Box className={styles.panelTable} sx={evalTableSx}>
        <DataTable ref={dtFields}
          value={orderedFields}
          reorderableRows
          onRowReorder={(e) => handleReorderFields(e)}
          dataKey="id"
          scrollable
          scrollHeight={onAddEvaluationRowVisibility ? "calc(100vh - 360px)" : "calc(100vh - 260px)"}
          sortMode="single"
          sortField="rank"
          rowClassName={rowClass}
          emptyMessage={
            <SettingsEmptyState
              icon="pi-list"
              title={<Langs str="SETTINGS_EVAL_NO_QUESTIONS_TITLE" />}
              description={<Langs str="SETTINGS_EVAL_NO_QUESTIONS_DESC" />}
            />
          }
        >
          <Column rowReorder style={{ width: '3rem', maxWidth: '3rem' }} />
          <Column field="title" body={questionBody} header={<Langs str="Question" />}></Column>
          <Column
            field="team_impact"
            header={<Langs str="EVAL_FIELD_TEAM_IMPACT" />}
            style={{ width: '8rem', maxWidth: '8rem' }}
            body={teamImpactBody}
          ></Column>
          <Column field="id" body={handleEditField} style={{ width: '6.5rem', maxWidth: '6.5rem' }} alignFrozen="right" frozen={true}></Column>
        </DataTable>
      </Box>
    )
  }

  /**
   * Deleting a question destroys every answer recorded against it, so the confirmation has
   * to be readable. It was a PrimeReact Dialog pinned at `width: 30vw` — 108px on a 360px
   * phone — with no way out except the header X: the only button in it was DELETE. Now an
   * MUI dialog with a real Cancel, sized to the viewport, and the destructive action last.
   * Not fullScreen on phone: a three-line confirmation does not need the whole screen, and
   * full-screen confirmations read as a page you have navigated to rather than a question.
   */
  function renderConfirmDeleteDialog() {
    const field = allEvaluationFields.find(field => field.id === deleteFieldId)
    const closeDialog = () => { setConfirmDeleteDialog(false); setDeleteFieldId(null) }
    const onPhone = isMobile === 2
    return (
      <MuiDialog
        open={confirmDeleteDialog}
        onClose={closeDialog}
        fullWidth
        maxWidth="xs"
        aria-labelledby="eval-delete-question-title"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            m: 2,
            width: "calc(100% - 32px)",
            maxHeight: "calc(100% - 32px)",
          },
        }}
      >
        <DialogTitle
          id="eval-delete-question-title"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            fontFamily: "roboto, sans-serif",
            fontSize: "18px",
            fontWeight: 700,
            color: "rgb(0,40,128)",
            pb: 1,
          }}
        >
          <WarningAmberRoundedIcon aria-hidden="true" sx={{ color: "#c62828" }} />
          <Langs str="DELETE_QUESTION" />
        </DialogTitle>
        <DialogContent sx={{ pb: 1 }}>
          <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "rgba(0,0,0,0.82)", wordBreak: "break-word" }}>
            {field && field.title}
          </Typography>
          <Typography sx={{ mt: 1.5, fontSize: "14px", lineHeight: 1.5, color: "#b3261e" }}>
            <Langs str="FIELD_DELETE_QUESTION_MESSAGE" />
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 2.5,
            pt: 1,
            gap: 1.5,
            flexDirection: onPhone ? "column-reverse" : "row",
            alignItems: "stretch",
            "& > :not(style) ~ :not(style)": { ml: 0 },
          }}
        >
          <Button
            onClick={closeDialog}
            fullWidth={onPhone}
            sx={{ minHeight: 46, borderRadius: "10px", textTransform: "none", fontWeight: 600, color: "rgba(45,42,38,0.7)" }}
          >
            <Langs str="CANCEL" />
          </Button>
          <Button
            onClick={() => handleDeleteEvaluationField(deleteFieldId)}
            variant="contained"
            color="error"
            disableElevation
            fullWidth={onPhone}
            startIcon={<DeleteOutlineRoundedIcon />}
            sx={{ minHeight: 46, px: 3, borderRadius: "10px", textTransform: "none", fontWeight: 700 }}
          >
            <Langs str="DELETE" />
          </Button>
        </DialogActions>
      </MuiDialog>
    )
  }

  const handleEvaluationTypeChange = (e) => {
    setSelectedEvaluationTypeLocal(e.value)
  }

  const handleMenuChange = (selectedList) => {
    setSelectedMenu(selectedList[0])
  }

  const handleMenuChangeV2 = (e) => {
    setSelectedMenu(e.value)
  }

  let sampleLeavesLayout = constructLayoutForSampleLeaves()

  // Determine if the add button should show on mobile
  const showMobileAddButton = isOwner(userRoleId) && (
    menuList[selectedMenu] === "Postes" ||
    menuList[selectedMenu] === "Compétence" ||
    menuList[selectedMenu] === "Modèles d'horaires"
  )



  /**
   * The évaluations questionnaire tab: evaluation TYPES on one side, the selected type's
   * QUESTIONS on the other.
   *
   * Desktop was a Bootstrap `Row` of `Col xxl` wrapping `.menuContent` / `.menuContentV`,
   * two classes that hard-code their own left offset against the fixed settings rail. That
   * only lines up at two specific widths: between 1200px and 1399px the columns had already
   * stacked while `.menuContentV` still had `margin-left: 0`, so the questions panel slid
   * underneath the rail. The shell is a CSS grid now, offset once on the container, so the
   * split point and the rail offset can no longer disagree.
   *
   * Phone gets a different structure entirely (MobileEvaluationsQuestionnaireTab): a
   * master/detail stacked at 360px is two full-height tables you scroll between, with
   * nothing left to say which questions belong to which type.
   *
   * Nothing here changes what is dispatched or saved.
   */
  function renderEvaluationsQuestionnaire() {
    const onPhone = isMobile === 2
    const typesCount = Array.isArray(orederedTypes) ? orederedTypes.length : 0
    const questionsCount = Array.isArray(orderedFields) ? orderedFields.length : 0
    // handleAddEvaluationField / handleDeleteEvaluationField both refuse non-admins, so
    // the affordances follow the same test instead of being dead controls.
    const canEditQuestions = isAdmin(userRoleId)

    const sharedOverlays = (
      <>
        {renderConfirmDeleteDialog()}
        <EvaluationTypeModal />
        <EvaluationFieldModal />
      </>
    )

    if (onPhone) {
      return (
        <>
          <MobileEvaluationsQuestionnaireTab
            types={orederedTypes}
            fields={orderedFields}
            selectedType={selectedEvaluationTypeLocal}
            canEdit={canEditQuestions}
            onSelectType={(type) => handleEvaluationTypeChange({ value: type })}
            onBack={() => handleEvaluationTypeChange({ value: null })}
            onAddType={() => { dispatch(setTypeModalVisibilty(true)) }}
            onEditType={(id) => { dispatch(setTypeModalVisibilty(true)); dispatch(setOnEditType(id)) }}
            onEditField={(id) => { dispatch(setFieldModalVisibilty(true)); dispatch(setOnEditField(id)) }}
            onDeleteField={(id) => { setConfirmDeleteDialog(true); setDeleteFieldId(id) }}
            onReorderTypes={handleReorderTypes}
            onReorderFields={handleReorderFields}
            onShowAddRow={handleAddEvaluationFieldVisibility}
            addRow={renderAddEvaluationRow()}
            addRowVisible={onAddEvaluationRowVisibility}
          />
          {sharedOverlays}
        </>
      )
    }

    const panelCardSx = {
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
      backgroundColor: "white",
      borderRadius: "14px",
      border: "1px solid rgba(0, 40, 128, 0.07)",
      boxShadow: "rgb(9 30 66 / 6%) 0px 8px 20px, rgb(95 106 126 / 6%) 0px 0px 1px",
    }

    const panelAddButtonSx = {
      width: 40,
      height: 40,
      borderRadius: "10px",
      color: "rgb(255,144,21)",
      backgroundColor: "rgba(255,144,21,0.1)",
      border: "1px solid rgba(255,144,21,0.25)",
      "&:hover": { backgroundColor: "rgba(255,144,21,0.2)" },
    }

    return (
      <>
        <Box
          sx={{
            /* 248px rail + 20px gutter, matching .menuContent's offset, applied once. */
            ml: "268px",
            mr: "20px",
            pt: "32px",
            pb: "24px",
            display: "grid",
            gap: "20px",
            alignItems: "start",
            gridTemplateColumns: { xs: "minmax(0, 1fr)", lg: "minmax(0, 7fr) minmax(0, 5fr)" },
          }}
        >
          <Box sx={panelCardSx}>
            <SettingsPanelHeader
              icon="pi-check-square"
              title={<Langs str='TYPES' />}
              description={<Langs str="SETTINGS_EVAL_TYPES_DESC" />}
              actions={
                <>
                  {typesCount > 0 && (
                    <span className={styles.countBadge}>{typesCount}</span>
                  )}
                  <IconButton
                    aria-label={Localize("SETTINGS_EVAL_ADD_TYPE")}
                    title={Localize("SETTINGS_EVAL_ADD_TYPE")}
                    onClick={() => { dispatch(setTypeModalVisibilty(true)); }}
                    sx={panelAddButtonSx}
                  >
                    <AddRoundedIcon sx={{ fontSize: 21 }} />
                  </IconButton>
                </>
              }
            />
            {renderEvaluationTypes()}
          </Box>

          <Box sx={panelCardSx}>
            <SettingsPanelHeader
              icon="pi-list"
              title={<Langs str="QUESTIONS" />}
              /* Which type these questions belong to was only ever legible from a filter
                 dropdown that duplicated the row selection on the left. The panel names
                 the type itself now, and the dropdown is gone. */
              description={
                selectedEvaluationTypeLocal ? (
                  <Box component="span" sx={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: 0.75 }}>
                    <Box component="span" sx={{ fontWeight: 700, color: "rgb(0,40,128)" }}>
                      {selectedEvaluationTypeLocal.title}
                    </Box>
                    <Box component="span" sx={{ color: "rgba(45,42,38,0.4)" }}>·</Box>
                    <Langs str="SETTINGS_EVAL_QUESTIONS_DESC" />
                  </Box>
                ) : (
                  <Langs str="SETTINGS_EVAL_QUESTIONS_DESC" />
                )
              }
              actions={
                selectedEvaluationTypeLocal ? (
                  <>
                    {questionsCount > 0 && (
                      <span className={styles.countBadge}>{questionsCount}</span>
                    )}
                    {canEditQuestions && !onAddEvaluationRowVisibility && (
                      <IconButton
                        aria-label={Localize("SETTINGS_EVAL_ADD_QUESTION")}
                        title={Localize("SETTINGS_EVAL_ADD_QUESTION")}
                        onClick={handleAddEvaluationFieldVisibility}
                        sx={panelAddButtonSx}
                      >
                        <AddRoundedIcon sx={{ fontSize: 21 }} />
                      </IconButton>
                    )}
                  </>
                ) : null
              }
            />
            {selectedEvaluationTypeLocal ? (
              <>
                {renderEvaluationFields()}
                {renderAddEvaluationRow()}
              </>
            ) : (
              <SettingsEmptyState
                icon="pi-list"
                title={<Langs str="SETTINGS_EVAL_QUESTIONS_EMPTY_TITLE" />}
                description={<Langs str="SETTINGS_EVAL_QUESTIONS_EMPTY_DESC_LIST" />}
              />
            )}
          </Box>
        </Box>
        {sharedOverlays}
      </>
    )
  }

  function renderMobileContent() {
    if (selectedMenu === menuList.indexOf("Réglages généraux"))
      return <MobileGeneralSettingsTab />
    else if (selectedMenu === menuList.indexOf("Modèles d'horaires"))
      return <MobileShiftTemplatesTab mobileAddRef={mobileAddRef} />
    else if (selectedMenu === menuList.indexOf("Jours fériés"))
      return <div style={{ marginTop: -90 }}><HolidaysTab menuLabel={menuList[selectedMenu]} /></div>
    else if (selectedMenu === menuList.indexOf("Postes"))
      return <MobilePostesTab mobileAddRef={mobileAddRef} />
    else if (selectedMenu === menuList.indexOf("Compétence"))
      return <MobileSkillsTab mobileAddRef={mobileAddRef} />
    // Same tab as the desktop. It had no branch here, so on a phone the entry showed in the
    // settings menu and opened nothing at all.
    else if (selectedMenu === menuList.indexOf("Questionnaire d'évaluations"))
      return renderEvaluationsQuestionnaire()
    return null
  }

  function renderMenuContent() {
    if (selectedMenu === menuList.indexOf("Réglages généraux")) {
      return <GeneralSettingsTab />
    }
    else if (selectedMenu === menuList.indexOf("Réglages clients"))
      return <ClientSettingsTab />
    else if (selectedMenu === menuList.indexOf("Modèles d'horaires"))
      return <ShiftTemplatesTab menuLabel={menuList[selectedMenu]} />
    else if (selectedMenu === menuList.indexOf("Congés"))
      return <Row className="m-0">
        <Col xxl={1}>
        </Col>
        <Col xxl={8} className="d-flex align-content-center">
          <div className={styles.menuContent}>
            <SettingsPanelHeader
              icon="pi-sun"
              title={<Langs str={menuList[selectedMenu]} />}
              description={<Langs str="SETTINGS_LEAVE_TEMPLATES_DESC" />}
              actions={
                <>
                  {sampleLeavesLayout.length > 0 && (
                    <span className={styles.countBadge}>{sampleLeavesLayout.length}</span>
                  )}
                  <ImageButton
                    onClick={handleAddSampleLeave}
                    image={addIcon}
                    imageFocus={addIconFocus}
                    tooltip={<Langs str="ADD" />}
                    active={true}
                    width={32}
                  />
                </>
              }
            />
            {sampleLeavesLayout.length === 0 ? (
              <SettingsEmptyState
                icon="pi-sun"
                title={<Langs str="SETTINGS_LEAVE_TEMPLATES_EMPTY_TITLE" />}
                description={<Langs str="SETTINGS_LEAVE_TEMPLATES_EMPTY_DESC" />}
              />
            ) : (
              <div className={styles.panelBody}>
                <ReactGridLayout
                  ref={sampleLeavesRef}
                  layout={sampleLeavesLayout}
                  items={sampleLeavesLayout.length}
                  rowHeight={48}
                  cols={1}
                  isResizable={false}
                  isDraggable={true}
                  isBounded={true}>
                  {sampleLeavesLayout.map((item) => {
                    return (
                      <div key={item["i"]}>
                        <ShiftCell
                          data={item.data}
                          isInteractive={true}
                          key={`ShiftCell_${item["i"]}`} />
                      </div>
                    )
                  })}
                </ReactGridLayout>
              </div>
            )}
          </div>
        </Col>
      </Row>
    else if (selectedMenu === menuList.indexOf("Jours fériés"))
      return <HolidaysTab menuLabel={menuList[selectedMenu]} />
    else if (selectedMenu === menuList.indexOf("Questionnaire d'évaluations"))
      // Re-enabled: this tab was commented out on 2026-02-27 (052b6fb9) and returned an
      // empty element, so there was no way to add an evaluation type or its questions
      // from the app at all. It is the entry point for configuring a type's prime
      // report, so it has to be reachable.
      return renderEvaluationsQuestionnaire()
    else if (selectedMenu === menuList.indexOf("Postes")) {
      return <PostesTab />
    }
    else if (selectedMenu === menuList.indexOf("Compétence")) {
      return <SkillsTab />
    }

  }

  if (isMobile == 2) {
    return (
      <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
        <MobileSettingsView
          menuList={menuList}
          selectedMenu={selectedMenu}
          onMenuChange={(v) => setSelectedMenu(v)}
          onAddAction={() => mobileAddRef.current && mobileAddRef.current()}
          showAddButton={showMobileAddButton}
        >
          {renderMobileContent()}
        </MobileSettingsView>
        <ShiftFormModal
          show={showFormPopup}
          onHide={() => dispatch(hideFormPopup())}
          isMobile={isMobile}
        />
      </div>
    )
  }

  return (
    <div className={styles.settingsView}>
      <div>
        <nav className={styles.leftMenu} aria-label={Localize("Settings")}>
          <label className={styles.leftMenuTitle}>
            <Langs str="Settings" />
          </label>
          <span className={styles.leftMenuSubtitle}>
            <Langs str="SETTINGS_SUBTITLE" />
          </span>

          <div className={styles.menuItems}>
            {menuList.map((item, index) => {
              const isSelected = index === selectedMenu
              // Group label is drawn above the first item of each run, so the
              // menu reads as sections without changing menuList's shape.
              const groupLabel =
                MENU_GROUPS[item] &&
                MENU_GROUPS[item] !== MENU_GROUPS[menuList[index - 1]]
                  ? MENU_GROUPS[item]
                  : null

              return (
                <React.Fragment key={`MENU_${index}`}>
                  {groupLabel && (
                    <div className={styles.menuGroupLabel}>
                      <Langs str={groupLabel} />
                    </div>
                  )}
                  <button
                    value={index}
                    aria-current={isSelected ? "true" : undefined}
                    title={Localize(item)}
                    className={`${styles.settingsButton} ${isSelected ? styles.settingsButtonSelected : ""}`}
                    onClick={() => setSelectedMenu(index)}
                  >
                    <i className={`pi ${MENU_ICONS[item] || "pi-cog"} ${styles.menuIcon}`} aria-hidden="true" />
                    <div className={isSelected ? styles.selectedLabel : styles.menuLabel}>
                      <Langs str={item} />
                    </div>
                  </button>
                </React.Fragment>
              )
            })}
          </div>

          <label className={styles.versionLabel}>Version {pjson.version}</label>
        </nav>
      </div>
      {renderMenuContent()}
      <ShiftFormModal
        show={showFormPopup}
        onHide={() => dispatch(hideFormPopup())}
      />
    </div>
  )
}
